import { FunctionComponent, h } from 'preact';
import AddressIcon from '../address-icon/address-icon';

export interface AddressProps {
	address: string;
	distance: number;
	description: string;
	translations: AddressTranslations;
	position?: number;
}

interface AddressTranslations {
	distanceUnit: string;
}

const Address: FunctionComponent<AddressProps> = ({ address, distance, description, translations, position }) => {
	return (
		<div className="address">
			<div className="left">
				<AddressIcon position={position} />
				<div className="distance">
					{distance}
					{translations.distanceUnit}
				</div>
			</div>
			<div className="right">
				<div className="address-title">{address}</div>
				<div className="description">{description}</div>
			</div>
		</div>
	);
};

export default Address;
